export default [
  { label: 'Vírgula', value: ',' },
  { label: 'Ponto e vírgula', value: ';' },
  { label: 'Tabulação', value: '\t' },
  { label: 'Espaço', value: ' ' },
  { label: 'Outro', value: 'outro' },
];
